export default __webpack_public_path__ + "static/media/loaderVideo.592ff228.mp4";